/**
 * @generated SignedSource<<bf3954bde459467b4fbc380178401a66>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PaymentPixAutomatic_subscription$data = {
  readonly comment: string | null | undefined;
  readonly company: {
    readonly nameFriendly: string | null | undefined;
    readonly projectType: string | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"PaymentCompanyLogo_company" | "PaymentCompanySupport_company">;
  } | null | undefined;
  readonly frequency: string | null | undefined;
  readonly id: string;
  readonly isActive: boolean | null | undefined;
  readonly value: number | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"PaymentPixAutomaticAdditionalInfo_subscription" | "PaymentPixAutomaticCompleted_subscription" | "PaymentPixAutomaticQRCode_subscription" | "PaymentPixAutomaticTitle_subscription" | "PaymentPixAutomaticTransactionInfo_subscription">;
  readonly " $fragmentType": "PaymentPixAutomatic_subscription";
};
export type PaymentPixAutomatic_subscription$key = {
  readonly " $data"?: PaymentPixAutomatic_subscription$data;
  readonly " $fragmentSpreads": FragmentRefs<"PaymentPixAutomatic_subscription">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PaymentPixAutomatic_subscription",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isActive",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "value",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "frequency",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "comment",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Company",
      "kind": "LinkedField",
      "name": "company",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "projectType",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "nameFriendly",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PaymentCompanySupport_company"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PaymentCompanyLogo_company"
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentPixAutomaticQRCode_subscription"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentPixAutomaticAdditionalInfo_subscription"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentPixAutomaticCompleted_subscription"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentPixAutomaticTitle_subscription"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentPixAutomaticTransactionInfo_subscription"
    }
  ],
  "type": "PaymentSubscription",
  "abstractKey": null
};

(node as any).hash = "aa3bc6a0871c312dc4250074f97466f8";

export default node;
